//src/config/apiConfig.js
export const API_BASE_URL = 'https://api.nnetego.com/api'; //https://api.nnetego.com
